"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactHookForm = require("react-hook-form");
var _reactTracking = require("react-tracking");
var _iconDown = _interopRequireDefault(require("../../icons/icon-down.svg"));
const StyledSelect = _styled.default.select(_ref => {
  let {
    theme,
    direction
  } = _ref;
  const side = direction === 'ltr' ? 'right' : 'left';
  return {
    appearance: 'none',
    background: `transparent url(${_iconDown.default}) no-repeat bottom 50% ${side} 14px`,
    border: '0',
    borderRadius: '5px',
    color: theme === null || theme === void 0 ? void 0 : theme.colors.inputText,
    fontSize: theme === null || theme === void 0 ? void 0 : theme.fontSizes.small,
    fontWeight: theme === null || theme === void 0 ? void 0 : theme.fontWeights.regular,
    lineHeight: '1',
    outline: '0',
    padding: '25px 25px 10px 16px',
    height: '52px',
    width: '100%',
    '&:hover': {
      cursor: 'pointer'
    },
    '&::placeholder': {
      color: theme === null || theme === void 0 ? void 0 : theme.colors.grey[500],
      fontWeight: theme === null || theme === void 0 ? void 0 : theme.fontWeights.regular,
      opacity: 0
    },
    '&:focus::placeholder': {
      opacity: 1
    }
  };
});

/**
 * A simple select meant to be mainly used in the Input component.
 */
const Select = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  let {
    control,
    direction,
    disabled = false,
    id,
    isTracking = false,
    onBlur,
    onFocus,
    options,
    register
  } = _ref2;
  const {
    trackEvent
  } = (0, _reactTracking.useTracking)();
  const newOption = (0, _reactHookForm.useWatch)({
    control,
    name: id
  });
  const oldOption = (0, _react.useRef)(newOption);
  const handleTracking = () => {
    if (isTracking) {
      trackEvent({
        event_name: 'option-selected',
        event_type: 'click',
        newOption,
        oldOption: oldOption.current
      });
      oldOption.current = newOption;
    }
  };
  (0, _react.useEffect)(() => {
    handleTracking();
  }, [newOption]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react.default.createElement(StyledSelect, Object.assign({
    direction: direction,
    disabled: disabled,
    id: id,
    ref: ref,
    onBlur: onBlur,
    onFocus: onFocus
  }, register(id)), Array.isArray(options) ? options.map(option => /*#__PURE__*/_react.default.createElement("option", {
    key: `${id}-${option}`,
    value: option
  }, option)) : Object.keys(options).map(key => /*#__PURE__*/_react.default.createElement("option", {
    disabled: key === 'noValue',
    key: `${id}-${key}`,
    value: key === 'noValue' ? '' : key
  }, options[key])));
});
Select.displayName = 'Select';
var _default = exports.default = Select;